


















































































































import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { IUserFields } from '@/common/types';
import { PolicyRisks } from '@/common/Policy';

import SelectField from '@/components/Form/SelectField.vue';
import TextField from '@/components/Form/TextField.vue';
import Checkbox from '@/components/Form/Checkbox.vue';
import SwitchField from '@/components/Form/SwitchField.vue';
import Loading from '@/components/Global/Loading.vue';
import UserInvite from '@/components/UserInvites/UserInvite.vue';
import NewInvite from '@/components/UserInvites/NewInvite.vue';
import Alert from '@/components/Global/Alert.vue';
import Policy from '@/services/Policy';
import Validation from '@/components/Form/Validation.vue';
import { mapGetters } from 'vuex';
import store from '@/store';
import { required, email } from 'vuelidate/lib/validators';

// Services
import Admin from '@/services/Admin';
import Auth from '@/services/Auth';
import UmiaRoles from '@/components/Staff/UserManagement/Roles/UmiaRoles.vue';
import * as Sentry from '@sentry/browser';
import Brand from '@/services/Brand';

@Component({
	name: 'PageInviteUsers',
	components: {
		SelectField,
		TextField,
		SwitchField,
		Alert,
		Checkbox,
		UserInvite,
		NewInvite,
		Loading,
		UmiaRoles,
	},
	validations: {
		users: {
			$each: {
				email: {
					email,
					required,
				},
				fullName: {
					required,
				},
			},
		},
	},
})
export default class InviteUsers extends Vue {
	@Getter('policies', { namespace: 'Policy' }) private policies;
	private loading: boolean;
	private risksLoading: boolean;
	private error: boolean;
	private roles: any[];
	private invitationSent: boolean;
	private isInvalid: boolean;
	private userFields: IUserFields;
	private users: IUserFields[];
	private risks: any;
	private Auth: any;
	private roleComponent: any = undefined;
	private Brand: any = Brand;

	constructor() {
		super();

		this.loading = false;
		this.risksLoading = false;
		this.error = false;
		this.roles = [];
		this.invitationSent = false;
		this.isInvalid = false;
		this.risks = [];
		this.userFields = {
			fullName: '',
			email: '',
			role: '',
			policy_number: '',
			client_id: '',
			brand: '',
			staff_invite: true,
			permissions: {
				ACCOUNT_ADMIN: false,
				BILL_PAY: false,
				COVERAGE_TABLE: false,
				PAYMENT_HISTORY: false,
				REPORT_CLAIM: false,
				STAFF: false,
				VIEW_CLAIMS: false,
				VIEW_CME: false,
				VIEW_COI: false,
				VIEW_CYBER_SOLUTIONS: false,
				VIEW_LATEST_NEWS: false,
				VIEW_POLICY_INFO: false,
				VIEW_RISK_MANAGEMENT: false,
				VIEW_SAVED_QUOTES: false,
			},
			policies: {},
		};
		this.users = [
			{
				fullName: '',
				email: '',
				role: '',
				policy_number: '',
				client_id: '',
				brand: '',
				staff_invite: true,
				permissions: {
					ACCOUNT_ADMIN: false,
					BILL_PAY: false,
					COVERAGE_TABLE: false,
					PAYMENT_HISTORY: false,
					REPORT_CLAIM: false,
					STAFF: false,
					VIEW_CLAIMS: false,
					VIEW_CME: false,
					VIEW_COI: false,
					VIEW_CYBER_SOLUTIONS: false,
					VIEW_LATEST_NEWS: false,
					VIEW_POLICY_INFO: false,
					VIEW_RISK_MANAGEMENT: false,
					VIEW_SAVED_QUOTES: false,
				},
				policies: {},
			},
		];

		this.Auth = Auth;
	}

	get userOrAgent() {
		if (
			this.$store.state.Auth.user.isAgent === 'true' &&
			this.$store.state.Auth.user.isOrgAdmin === 'true'
		) {
			return 'Agent';
		}

		return 'User';
	}

	private async created() {
		try {
			this.risksLoading = true;
			await this.$store.dispatch('Misc/getRoles');

			switch (Brand.getBrand()) {
				case 'mmic':
					this.roleComponent = () =>
						import(
							/* webpackChunkName: "Roles" */ '@/components/Staff/UserManagement/Roles/MmicRoles.vue'
						);
					break;

				case 'umia':
					this.roleComponent = () =>
						import(
							/* webpackChunkName: "Roles" */ '@/components/Staff/UserManagement/Roles/UmiaRoles.vue'
						);
					break;

				case 'amic':
					this.roleComponent = () =>
						import(
							/* webpackChunkName: "Roles" */ '@/components/Staff/UserManagement/Roles/AmicRoles.vue'
						);
					break;

                                case 'rrg':
                                        this.roleComponent = () =>
                                                import(
                                                        /* webpackChunkName: "Roles" */ '@/components/Staff/UserManagement/Roles/RrgRoles.vue'
                                                );
                                        break;

			}
		} catch (e) {
			Sentry.captureException(e);
			this.risksLoading = false;
		} finally {
			this.risksLoading = false;
		}
	}

	private deleteUser(index) {
		this.users.splice(index, 1);
	}

	private addMore() {
		this.users.push(Object.assign({}, this.userFields));
	}

	private async inviteUsers() {
		this.$v.$touch();
		this.error = false;
		this.invitationSent = false;
		if (this.$v.$invalid) {
			this.isInvalid = true;
			return;
		}
		this.loading = true;
		// tslint:disable-next-line: prefer-const
		let users = [];
		this.users.forEach(user => {
			if (user.fullName && user.email) {
				user.email = user.email.toLowerCase();
				user.brand = Brand.getBrand();
				const index = parseInt(user.selectedRiskIndex, 0);
				if (index >= 0 && this.risks[index] !== null) {
					user.policy_number = this.risks[index].policy_number;
					user.client_id = this.risks[index].client_id;
				} else {
					// tslint:disable-next-line: prefer-const
					let policies = [];
					for (const policy of this.policies) {
						if (user.policies[policy.policy_number]) {
							policies.push({
								policy_number: policy.policy_number,
								client_id: policy.client_id,
							});
						}
					}
					user.policies = policies;
				}

				users.push(user);
			}
		});
		if (!users) {
			return;
		}
		try {
			const inviteUsers = await Admin.inviteUsers(users);
			this.invitationSent = true;
			console.log(inviteUsers);
		} catch (e) {
			console.log(e);
			Sentry.captureException(e);
			this.error = e;
			this.loading = false;
			this.invitationSent = false;
		} finally {
			this.loading = false;
			if (this.invitationSent) {
				this.users = [];
				this.users.push(Object.assign({}, this.userFields));
			}
		}
	}
}
